<script lang="ts" setup>
import type { IContentElement } from '@bosca/analytics-client-browser'
import type { ProfileStudy, Study, StudySession } from '~/utils/generated/graphql'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import CircleCheck from '~/assets/images/cirlce_check.svg?component'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import CircleUncheck from '~/assets/images/circle_uncheck.svg?component'

const carousel = ref()
const props = defineProps<{
  study: Study
  profile: ProfileStudy | null | undefined
}>()

const completedIds = computed(() => {
  const completed: { [id: string]: boolean } = {
    about: true,
  }
  if (props.profile?.completedSessionIds) {
    for (const id of props.profile.completedSessionIds) {
      completed[id] = true
    }
  }
  return completed
})

const items = computed(() => {
  return [{ id: 'about' }, ...props.study.sessions]
})

watch(carousel, () => {
  let check = 0
  check = setInterval(() => {
    if (!carousel.value) return
    clearInterval(check)
    const ix = props.study.sessions.findIndex(s => s.id === props.study.session?.id)
    carousel.value.select(ix)
  }, 100) as unknown as number
})

function newContent(item: StudySession, index: number): IContentElement[] {
  return [{ id: props.study.id, type: 'Study', index: index }, { id: item.id, type: 'StudySession', index: index }] as IContentElement[]
}
</script>

<template>
  <div class="w-full mt-2">
    <ContentControls
      :item="study"
    />
    <div class="w-full flex mt-4">
      <UCarousel
        ref="carousel"
        v-slot="{ item, index }"
        :items="items"
        :ui="{ container: 'gap-4' }"
        class="w-full overflow-auto"
      >
        <PLink
          v-if="index === 0"
          :id="'session-item-' + item.id"
          :content="newContent(item, index)"
          :extras="{ slug: study.slug }"
          :class="'flex gap-2 no-underline font-[600] rounded-lg py-2 px-4 hover:text-white hover:stroke-white hover:fill-white items-center ' + (!study.session?.id ? 'bg-bluedark-300 hover:bg-blurple-600' : 'bg-blurple-100 hover:bg-blurple-700')"
          :to="'/studies/' + study.slug"
        >
          {{ $t('introduction') }}
          <CircleCheck
            v-if="profile?.started"
            class="w-6 h-6"
          />
          <CircleUncheck
            v-else
            class="w-6 h-6"
          />
        </PLink>
        <PLink
          v-else
          :id="'session-item-' + item.id"
          :content="newContent(item, index)"
          :extras="{ slug: study.slug }"
          :to="'/studies/' + study.slug + '/' + item.id.split('-')[1]"
          :class="'flex gap-2 no-underline font-[600] rounded-lg py-2 px-4 hover:text-white hover:stroke-white hover:fill-white items-center ' + (study.session?.id === item.id ? 'bg-bluedark-300 hover:bg-blurple-600' : 'bg-blurple-100 hover:bg-blurple-700')"
        >
          {{ $t('dayN', { n: index }) }}
          <CircleCheck
            v-if="completedIds[item.id]"
            class="w-6 h-6"
          />
          <CircleUncheck
            v-else
            class="w-6 h-6"
          />
        </PLink>
      </UCarousel>
    </div>
  </div>
</template>
